<template>
    <div class="wizard-loading-state">
        <div class="wizard-loading-content">
            <div class="wizard-spinner"></div>
            
            <div class="wizard-loading-text">
                <h2 class="wizard-loading-title">{{ title }}</h2>
                <p class="wizard-loading-subtitle">{{ subtitle }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoadingState',
    props: {
        message: {
            type: String,
            default: 'Lade nächste Bestellung...'
        },
        subtitle: {
            type: String,
            default: 'Suche nach verfügbaren Bestellungen'
        }
    },
    computed: {
        title() {
            return this.message;
        }
    }
}
</script>

<style scoped>
.wizard-loading-state {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    padding: 32px;
}

.wizard-loading-content {
    text-align: center;
    max-width: 400px;
}

.wizard-spinner {
    width: 60px;
    height: 60px;
    border: 4px solid #e3f2fd;
    border-top: 4px solid #1976d2;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 32px auto;
}

.wizard-loading-text {
    margin-bottom: 24px;
}

.wizard-loading-title {
    font-size: 28px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
}

.wizard-loading-subtitle {
    font-size: 16px;
    color: #7f8c8d;
    line-height: 1.5;
    margin: 0;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

/* Responsive */
@media (max-width: 768px) {
    .wizard-loading-state {
        padding: 24px;
    }
    
    .wizard-loading-title {
        font-size: 24px;
    }
    
    .wizard-loading-subtitle {
        font-size: 14px;
    }
}
</style>
